import { DISMISS_CHANGELOG } from "@lib/graphql/mutations";
import { CHANGELOG_ENTRIES_QUERY, UNSEEN_CHANGELOG_ENTRIES_QUERY } from "@lib/graphql/queries";
import { BellPlus } from "lucide-react";
import { useState } from "react";
import { useMutation, useQuery } from "urql";
import { ChangelogModal } from "./ChangelogModal";

export function ChangelogButton() {
  const [open, setOpen] = useState(false);
  const [{ data: unseenData }] = useQuery({ query: UNSEEN_CHANGELOG_ENTRIES_QUERY });
  const [{ data: allData }, reexecuteAll] = useQuery({
    query: CHANGELOG_ENTRIES_QUERY,
    pause: !open,
  });
  const [, dismissChangelog] = useMutation(DISMISS_CHANGELOG);

  const unseenCount = unseenData?.unseenChangelogEntries?.length ?? 0;
  const allEntries = allData?.changelogEntries ?? [];

  const handleOpen = () => {
    setOpen(true);
    reexecuteAll({ requestPolicy: "network-only" });
  };

  const handleClose = async () => {
    setOpen(false);
    if (unseenCount > 0) {
      await dismissChangelog({ input: {} });
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="relative rounded-md p-1.5 text-text-muted transition-colors hover:bg-card-hover hover:text-text-secondary"
        title="What's new"
      >
        <BellPlus size={18} />
        {unseenCount > 0 && (
          <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full bg-indigo-600" />
        )}
      </button>

      {open && <ChangelogModal entries={allEntries} onClose={handleClose} />}
    </>
  );
}
